import { ReactElement } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import { useFormikContext } from 'formik';
import uniqueId from 'lodash/uniqueId';

// Styles
import styles from 'components/ContinuousImprovement/PureFormElements/FormikFields.module.scss';

// Types
import { IFacetProps, SearchRequest } from 'components/ContinuousImprovement/Facets/types';
import { FormikInputField } from 'components/ContinuousImprovement/PureFormElements';

export const TextInput = (props: IFacetProps): ReactElement => {
  const { callback, classes, facet, isDisabled, isExpanded, expandIcon, onToggleExpand } = props;
  const { setFieldValue } = useFormikContext<SearchRequest>();
  const { displayValue, payloadValue } = facet;

  const onKeyPress = (e): void => {
    const value = e.target.value;
    setFieldValue(payloadValue, value);

    // Clicking the enter button should call the callback.
    if (e.which === 13) {
      callback?.();
    }
  };

  return (
    <Accordion key={displayValue} className={classes.accordion} expanded={isExpanded} onChange={onToggleExpand}>
      <AccordionSummary className={classes.summary} expandIcon={expandIcon} id={uniqueId()}>
        {displayValue}
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <span className="search-box--small" style={{ width: 'auto' }}>
          <FormikInputField
            className={styles.input}
            disabled={isDisabled}
            formikKey={payloadValue}
            name={payloadValue}
            onKeyPress={onKeyPress}
            placeholder={displayValue}
            title={displayValue}
            type="text"
          />
        </span>
      </AccordionDetails>
    </Accordion>
  );
};
